import { atom } from 'recoil'

export interface SelectedPathIds {
  ids: string[]
}
const INIT_VALUE = { ids: [] }

export const $SelectedPathIds = atom<SelectedPathIds>({
  key: 'SelectedPathIds',
  default: INIT_VALUE,
})
